import { ReactNode } from 'react';
import { ConnectToSfAndHubspot } from './ConnectToSfAndHubspot';
import { HubspotSwitchToProduction } from './HubspotSwitchToProduction';
import { useHubspotUnhappyStates } from '../useHubspotUnhappyStates';

export const HubspotOrgBlockedViews = ({
  children,
  smallScreenVersion,
}: {
  children: ReactNode;
  smallScreenVersion?: boolean;
}) => {
  const { isRenderHubspotConnectPage, isRenderHubspotNotInProductionPage } =
    useHubspotUnhappyStates();

  if (isRenderHubspotConnectPage) {
    return <ConnectToSfAndHubspot smallScreenVersion={smallScreenVersion} />;
  }

  if (isRenderHubspotNotInProductionPage) {
    return <HubspotSwitchToProduction />;
  }

  return children;
};
